// extracted by mini-css-extract-plugin
export default {"header":"header__41Lz1","btn-save":"btn-save__oN0nH","title":"title__cYe-Q","avatar":"avatar__U-zB9","filters":"filters__VCcHm"};